//#region ../src/storage/write-file-or-abort.ts
/**
* Write `data` to `fileHandle`, aborting the writable stream if anything fails.
*
* On success the stream is closed, which atomically swaps the new content over
* the old. On failure the stream is aborted — discarding the temp and releasing
* the lock — and the original error is rethrown, so callers see the cause
* rather than a downstream lock error.
*
* @throws the underlying write/close error. A non-`Error` throw is normalized
* to an `Error` (using its string value when it is one) so callers can rely on
* `instanceof Error`.
*/
async function writeFileOrAbort(fileHandle, data) {
	const writable = await fileHandle.createWritable();
	try {
		await writable.write(data);
		await writable.close();
	} catch (error) {
		await writable.abort().catch(() => {});
		throw error instanceof Error ? error : new Error(typeof error === "string" ? error : "File write failed");
	}
}
//#endregion
export { writeFileOrAbort };
